var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.transactions.url,"title":"لیست کارت های ملی و سلفی ها","fields":_vm.transactions.fields,"params":_vm.transactions.params,"viewUrl":'ConfirmNationalCode',"detailCallFunType":_vm.transactions.detailCallFunType},on:{"handle_function_call":_vm.ShowDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }